import {Badge} from 'react-native-paper';
import AssignmentIcon from '~/images/md-icons/assignment/materialicons/24px.svg';
import ChatIcon from '~/images/md-icons/chat/materialicons/24px.svg';
import AssignmentOutlinedIcon from '~/images/md-icons/assignment/materialsymbolsoutlined/24px.svg';
import ChatOutlinedIcon from '~/images/md-icons/chat/materialsymbolsoutlined/24px.svg';
const RequestTabs = ({
  selectedTab,
  setSelectedTab,
  hasUnreadMessages,
  Tabs,
  TabBar,
}) => (
  <TabBar tab={selectedTab} onChangeTab={setSelectedTab}>
    <TabBar.Tab
      label={Tabs.Request}
      icon={{
        filled: <AssignmentIcon />,
        outlined: <AssignmentOutlinedIcon />,
      }}
    />
    <TabBar.Tab
      label={Tabs.Messages}
      badge={
        hasUnreadMessages ? (
          <Badge
            theme={{colors: {notification: '#B3261E'}}}
            visible={hasUnreadMessages}
            style={{position: 'absolute', top: 0, right: -2}}
            size={8}
          />
        ) : null
      }
      icon={{
        filled: <ChatIcon />,
        outlined: <ChatOutlinedIcon />,
      }}
    />
  </TabBar>
);
export default RequestTabs;
